(() => {
  if (window.kekkaVerdictReviewFormReady) return;
  window.kekkaVerdictReviewFormReady = true;

  const isVisible = element => element && element.getClientRects().length > 0;
  const findTrigger = () => {
    const selectors = [
      '#judgeme_product_reviews [data-testid="write-review-button"]',
      '#judgeme_product_reviews .jdgm-write-rev-link',
      '[data-testid="write-review-button"]'
    ];
    for (const selector of selectors) {
      // The native trigger is intentionally hidden behind our summary button.
      const trigger = [...document.querySelectorAll(selector)].find(element =>
        !element.disabled && element.getAttribute('aria-disabled') !== 'true'
      );
      if (trigger) return trigger;
    }
    return null;
  };

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-verdict-write-review]');
    if (!button || button.disabled) return;

    const status = button.closest('.verdict-summary').querySelector('.verdict-write-status');
    const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = 'Opening review form…';

    try {
      // Scrolling to the app also allows its lazy-loaded widget to initialise.
      document.getElementById('judgeme_product_reviews')?.scrollIntoView({ behavior, block: 'center' });
      const deadline = Date.now() + 10000;
      while (button.isConnected && Date.now() < deadline) {
        const widget = document.getElementById('judgeme_product_reviews');
        const form = widget?.querySelector('.jdgm-form');
        if (isVisible(form)) {
          form.scrollIntoView({ behavior, block: 'center' });
          form.querySelector('input:not([type="hidden"]), textarea, button')?.focus({ preventScroll: true });
          status.textContent = '';
          return;
        }

        const trigger = findTrigger();
        if (trigger) {
          trigger.click();
          status.textContent = '';
          return;
        }
        await new Promise(resolve => setTimeout(resolve, 100));
      }
      status.textContent = 'The review form could not load. Please try again.';
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
